import React from 'react';

/**
 * Top-level error fallback shown when a React error escapes a boundary.
 * Minimal — no shadcn dependency to keep the boundary itself robust.
 */
export default function SentryErrorFallback({ error, resetError }) {
  return (
    <div
      role="alert"
      data-testid="sentry-error-fallback"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        background: '#0f172a',
        color: '#e2e8f0',
        fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
      }}
    >
      <div style={{ maxWidth: 520, textAlign: 'center' }}>
        <h1 style={{ fontSize: 24, marginBottom: 12 }}>Something went wrong</h1>
        <p style={{ opacity: 0.8, marginBottom: 24, lineHeight: 1.5 }}>
          The page hit an unexpected error. Our team has been notified
          automatically. You can retry below.
        </p>
        {error?.message && (
          <pre
            style={{
              background: '#1e293b',
              padding: '12px 16px',
              borderRadius: 6,
              fontSize: 12,
              textAlign: 'left',
              overflow: 'auto',
              maxHeight: 160,
              marginBottom: 24,
            }}
          >
            {String(error.message).slice(0, 500)}
          </pre>
        )}
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
          <button
            type="button"
            data-testid="sentry-error-retry-btn"
            onClick={resetError}
            style={{
              background: '#3b82f6',
              color: '#fff',
              border: 'none',
              padding: '10px 18px',
              borderRadius: 6,
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            Try again
          </button>
          <button
            type="button"
            data-testid="sentry-error-reload-btn"
            onClick={() => window.location.reload()}
            style={{
              background: 'transparent',
              color: '#e2e8f0',
              border: '1px solid #475569',
              padding: '10px 18px',
              borderRadius: 6,
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            Reload page
          </button>
        </div>
      </div>
    </div>
  );
}
